import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';
import type {
	CommandConstructor,
	CommandProperties,
	SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';

/**
 * @see {@link OpenRovoSidePanelCommand}
 */
export interface OpenRovoSidePanelCommandProperties extends CommandProperties {
	/**
	 * Optional action ID to pre-select when opening the panel. If not provided, the panel will open with the current active action.
	 */
	actionId?: string;
	/**
	 * Optional prompt text to pre-fill in the chat input without sending it. This is useful when you want to
	 * suggest a message to the user without automatically triggering a response.
	 */
	prefillPrompt?: string;
}

export const OpenRovoSidePanelCommand: CommandConstructor<
	OpenRovoSidePanelCommandProperties,
	SerializableValue
> = createCommand<OpenRovoSidePanelCommandProperties>('open-rovo-side-panel');
